<template>
  <v-select
    :items="items"
    :label="label"
    @change="onInput"
    v-model="model"
    color="teal lighten-2"
    clearable
  ></v-select>
</template>
<script>
export default {
  name: 'bool-select',
  data () {
    return {
      model: this.value,
      items: [
        { text: 'Да', value: 'true' },
        { text: 'Не', value: 'false' }
      ]
    }
  },
  methods: {
    onInput () {
      this.$emit('input', this.model)
    }
  },
  props: {
    value: {},
    label: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
